import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { flightStatusMap } from "../../../pages/Orders/OrdersData";
import { isGDSSupplier } from "../../../data/flight/supplier/getSupplierName";
import { getTestLevel } from "../../../utils/testLevel";
import { ActionContext } from "../OrderList";
import useAccount from "../../../hooks/useAccount";
import { useInsuranceActions } from "../../../hooks/useInsuranceActions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import getBooking from "../../../controllers/booking/getBooking";
import Modal1 from "../../DIsplay/Modal/Modal1";
import FlightDoc from "../../../pages/Orders/Flight/Booked/FlightDoc";

export default function FlightMenu({ og, mobile }) {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const { searchForInsuranceFromFlightBooking } = useInsuranceActions();
  const bookingData = og?.flightBooking.at(0);
  const isPriceFreezeOrder = Boolean(bookingData?.priceFreezeId);
  const isInitiatedPriceFreeze =
    isPriceFreezeOrder && bookingData?.priceFreezeStatus === "Initiated";
  const { ticketFilterType } = useSelector((state) => state.order);

  const { checkPermission } = useAccount();

  const voidTime = new Date(bookingData?.voidDeadline || null);

  const navigate = useNavigate();

  const handleAddInsurance = () => {
    searchForInsuranceFromFlightBooking({ data: og });
  };
  // console.log({ og });

  return (
    <div
      className={`${
        mobile
          ? "flex flex-col z-10 w-full"
          : "absolute p-2 flex flex-col z-10 bg-white rounded-md right-2 top-full shadow-xl min-w-[200px]"
      } `}
      style={{
        boxShadow: "0 5px 15px #999",
      }}
    >
      <ActionContext.Consumer>
        {(value) => {
          const {
            reload,
            setOpenPayment,
            setOpenCancelOrder,
            setOpenApproveFreeze,
            setOpenManageFreeze,
            setOpenIssueTicket,
            setOpenRebook,
            setOpenVoidTicket,
            setOpenCancelTicket,
            refreshTicket,
            issue,
            manualIssue,
            approve,
            deny,
            requestInfo,
            approveVoid,
            denyVoid,
            refreshRefundFee,
            refreshRefund,
            approveRefund,
            denyRefund,
            setOpenEditRefund,
            refundTicket,
            approveChange,
            denyChange,
            setOpenEditChange,
            setOpenViewDetail,
            assignChangeTask,
            assignTicket,
            assignVoid,
            setOpenSubmitChange,
            setOpenUpdateChangeRequest,
            setOpenChangeQuote,
            setOpenEditTicket,
            setOpenManualChangeQuote,
            setOpenSubmitRefund,
            setOpenRefundQuote,
            setOpenManualUpdate,
            setOpenManualRefund,
            setOpenManualVoid,
            holdFlightBooking,
            setOpenPDFExport,
            setOpenEmailExport,
            addSeat,
            addBag,
            setOpenEditPayable,
          } = value || {};
          // Ticketed:
          // x View order
          // x Add a bag
          // x Change date
          // x Details Change
          // Void
          // x Refund (if refundable)

          // Pending Payment:
          // View order
          // Make payment
          // Hold booking
          // Add hotel
          // Add tour
          // Add insurance
          // Add bag
          // Add a seat
          // Cancel order

          // PAID:
          // View order
          // Issue ticket
          // Add hotel
          // Add tour
          // Add insurance
          // Add bag
          // Add a seat
          // Cancel order

          // Cancelled:
          // View order
          // Rebook order

          // Share
          // Share pdf
          // Share via email

          const postTicketing =
            og?.fee !== undefined || og?.ticketNo || og?.changeRequest;

          const isDefaultOrderMenu =
            !postTicketing &&
            ![
              "Tickets",
              "Void Orders",
              "Refund Orders",
              "Date Change",
              "Details Change",
            ].includes(ticketFilterType);

          const menus = [
            {
              label: postTicketing ? "View Request" : "View order",
              action: () => {
                switch (ticketFilterType) {
                  case "Date Change":
                    navigate(
                      "/order/flight/ticket/changedate/confirmation/" + og?._id,
                    );
                    break;
                  case "Details Change":
                    navigate(
                      "/order/flight/ticket/rename/confirmation/" + og?._id,
                    );
                    break;
                  case "Refund Orders":
                    navigate(
                      "/order/flight/ticket/refund/confirmation/" + og?._id,
                    );
                    break;
                  case "Void Orders":
                    navigate(
                      "/order/flight/ticket/void/confirmation/" + og?._id,
                    );
                    break;
                  default:
                    setOpenViewDetail({ id: og?._id, page: ticketFilterType });
                }
              },
              // action: () => navigate("/order/flight/ticket/detail/"+og?._id+'?page='+ticketFilterType),
            },
          ];

          if (isInitiatedPriceFreeze && isDefaultOrderMenu) {
            menus.push(
              {
                label: "Manage freeze",
                action: () => setOpenManageFreeze?.(og),
              },
              {
                label: "Approve freeze",
                action: () =>
                  setOpenApproveFreeze?.({
                    priceFreezeId: bookingData?.priceFreezeId,
                    status: "APPROVED",
                  }),
              },
              {
                label: "Decline freeze",
                action: () =>
                  setOpenApproveFreeze?.({
                    priceFreezeId: bookingData?.priceFreezeId,
                    status: "DECLINED",
                  }),
              },
              {
                label: "Cancel order",
                action: () => setOpenCancelOrder(og?.flightObj?._id),
                hide: !checkPermission("cancel:flight-booking"),
              },
            );
          } else {
            if (isPriceFreezeOrder && isDefaultOrderMenu) {
              menus.push({
                label: "Manage freeze",
                action: () => setOpenManageFreeze?.(og),
              });
            }

            menus.push({
              label: "Refresh Status",
              action: () => refreshTicket(bookingData?._id),
              showFor: ["Completed", "PendingVoid", "WaitingConfirmation"],
            });

            if (ticketFilterType === "Tickets") {
              menus?.push(
                ...[
                  {
                    label: "Issue Ticket",
                    action: () => issue(og?._id),
                    showFor: ["Pending", "RequestedInfo"],
                    hide: !checkPermission("issue:ticket"),
                  },
                  // {
                  //   label: "Edit Ticket",
                  //   action: () => setOpenEditTicket(og),
                  //   showFor: ["Approved", "Completed", "Issued"],
                  // },
                  {
                    label: "Manual Issue",
                    action: () => manualIssue(og),
                    showFor: ["Pending", "WaitingConfirmation"],
                  },
                  {
                    label: "Cancel Ticket",
                    action: () => setOpenCancelTicket(bookingData),
                    showFor: ["Ticket issued", "issued", "Completed"],
                  },
                  {
                    label: "Approve",
                    action: () => approve(og?._id),
                    showFor: ["Open"],
                  },
                  {
                    label: "Cancel Request",
                    action: () => deny(og),
                    // showFor: ["Open"],
                  },
                  {
                    label: "Request more info",
                    action: () => requestInfo(og),
                    showFor: ["Open"],
                  },
                  // {
                  //   label: "Assign",
                  //   action: () => assignTicket(og),
                  //   showFor: ["Approved", "Pending","RequestedInfo"],
                  // },
                ],
              );
            } else if (ticketFilterType === "Void Orders") {
              menus?.push(
                ...[
                  {
                    label: "Approve",
                    action: () => approveVoid(og?._id),
                    showFor: ["Pending"],
                  },
                  {
                    label: "Void Ticket",
                    action: () => setOpenVoidTicket(og?._id),
                    showFor: ["Approved"],
                  },
                  {
                    label: "Cancel Request",
                    action: () => denyVoid(og),
                    showFor: ["Pending", "Approved"],
                  },
                  {
                    label: "Manual Void",
                    action: () => setOpenManualVoid(og),
                    showFor: ["Approved"],
                  },
                  {
                    label: "Assign Request",
                    action: () => assignVoid(og),
                    showFor: ["Approved", "Pending"],
                  },
                ],
              );
            } else if (ticketFilterType === "Refund Orders") {
              menus?.push(
                ...[
                  {
                    label: "Refresh Status",
                    action: () => refreshRefund(og?._id),
                    showFor: ["PendingRefund"],
                  },
                  {
                    label: og?.tasks?.length ? "Re Assign" : "Assign Request",
                    action: () => refundTicket(og),
                    showFor: ["Pending", "Approved"],
                    // hide: !og?.confirmed,
                  },
                  {
                    label: "Accept Request",
                    action: () => approveRefund(og?._id),
                    showFor: ["Pending"],
                    // hide: !og?.priceReceived,
                  },
                  // {
                  //   label: "Edit Refund",
                  //   action: () => setOpenEditRefund(og),
                  //   showFor: ["Approved"],
                  //   hide: og?.confirmed === true,
                  // },
                  {
                    label: "Auto Quote",
                    action: () => refreshRefundFee(og?._id),
                    showFor: ["Approved"],
                    hide: og?.priceReceived,
                  },
                  {
                    label: og?.priceReceived ? "Edit Quote" : "Create Quote",
                    action: () => setOpenRefundQuote(og),
                    showFor: og?.priceReceived
                      ? ["Approved", "Pending"]
                      : ["Approved"],
                    hide: og?.confirmed,
                  },
                  {
                    label: "Confirm Airline Submission",
                    action: () => setOpenSubmitRefund(og?._id),
                    showFor: ["Approved"],
                    hide: !og?.confirmed,
                  },
                  {
                    label: "Re-imburse",
                    action: () => setOpenManualRefund(og),
                    showFor: ["PendingRefund"],
                    hide: !og?.confirmed,
                  },
                  {
                    label: "Decline Request",
                    action: () => denyRefund(og),
                    showFor: ["Pending", "Approved", "PendingRefund"],
                  },
                ],
              );
            } else if (
              ticketFilterType === "Date Change" ||
              ticketFilterType === "Details Change"
            ) {
              // user?.userType !== "Staff" &&
              true &&
                menus?.push(
                  ...[
                    {
                      label:
                        og?.changePrice && og?.changeFee
                          ? "Edit Quote"
                          : "Create Quote",
                      action: () =>
                        og?.newDirections
                          ? setOpenManualChangeQuote(og)
                          : setOpenChangeQuote(og),
                      // showFor: ["Approved"],
                    },
                    {
                      label: og?.tasks?.length ? "Re Assign" : "Assign Request",
                      action: () => assignChangeTask(og),
                      showFor: ["Pending", "Approved", "Paid"],
                    },
                    {
                      label: "Accept Request",
                      action: () => approveChange(og?._id),
                      showFor: ["Pending"],
                      // hide: !(og?.changeFee || og?.changePrice)
                    },
                    // {
                    //   label: "Edit Change Fee",
                    //   action: () => setOpenEditChange(og),
                    //   showFor: ["Pending"],
                    // },
                    {
                      label: "Add Remark",
                      action: () => setOpenUpdateChangeRequest(og),
                      showFor: ["Pending", "Approved"],
                    },
                    // {
                    //   label: 'Reissue Ticket',
                    //   action: () => assignChangeTask(og),
                    //   showFor: ['Approved']
                    // },
                    {
                      label: "Confirm Airline Submission",
                      action: () => setOpenSubmitChange(og?._id),
                      showFor: ["Paid"],
                    },
                    {
                      label: "Confirm Re-issue",
                      action: () => setOpenManualUpdate(og),
                      showFor: ["Pending Reissue", "PendingChange"],
                    },
                    {
                      label: "GDS Re-issue",
                      action: () => assignChangeTask(og),
                      showFor: ["Pending Reissue", "PendingChange"],
                      hide: !isGDSSupplier(
                        og?.supplier || og?.flightObj?.supplier,
                      ),
                    },
                    {
                      label: "Decline Request",
                      action: () => denyChange(og),
                      showFor: [
                        "Pending",
                        "Approved",
                        "Paid",
                        "Pending Reissue",
                      ],
                    },
                  ],
                );
            }

            if (!postTicketing)
              menus?.push(
                ...[
                  {
                    // label: "Make payment",
                    label: "Pay from agent wallet",
                    action: () => setOpenPayment(og?.flightObj?._id),
                    showFor: ["Not Paid", "booked"],
                    hide: !checkPermission("pay:ticket"),
                  },
                  {
                    label: "Issue Ticket",
                    action: () => setOpenIssueTicket(bookingData),
                    showFor: ["Paid", "issuable"],
                    hide: !checkPermission("issue:ticket"),
                  },
                  {
                    label: "Hold booking",
                    action: () => holdFlightBooking(og?.flightObj?._id),
                    showFor: ["Not Paid", "booked"],
                    hide: !checkPermission("hold:flight-booking"),
                  },
                  {
                    label: "Edit Payable",
                    action: () => setOpenEditPayable(og),
                    showFor: ["Not Paid", "booked"],
                    hide: !checkPermission("hold:flight-booking"),
                  },
                  {
                    label: "Add a bag",
                    action: () => addBag(og),
                    showFor: [
                      "Not Paid",
                      "booked",
                      "Ticket issued",
                      "issued",
                      "Paid",
                      "issuable",
                    ],
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Add a seat",
                    action: () => addSeat(og),
                    showFor: [
                      "Not Paid",
                      "booked",
                      "Ticket issued",
                      "issued",
                      "Paid",
                      "issuable",
                    ],
                  },
                  {
                    label: "Add hotel",
                    action: () => {},
                    showFor: ["Not Paid", "booked", "Paid", "issuable"],
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Add tour",
                    action: () => {},
                    showFor: ["Not Paid", "booked", "Paid", "issuable"],
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Add protection",
                    action: () => {
                      handleAddInsurance();
                    },
                    showFor: ["Not Paid", "booked", "Paid", "issuable"],
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Rebook",
                    action: () => setOpenRebook(og?.flightObj),
                    // showFor: ["Expired", "Canceled", "Ticket Canceled"],
                  },
                  // {
                  //   label: 'Cancel Ticket',
                  //   action: () => setOpenCancelTicket(bookingData),
                  //   showFor: ['Ticket issued','issued','Completed']
                  // },
                  {
                    label: "Change date",
                    action: () =>
                      navigate("/order/flight/ticket/changedate/" + og?._id),
                    showFor: ["Ticket issued", "issued"],
                  },
                  {
                    label: "Details Change",
                    action: () =>
                      navigate("/order/flight/ticket/changeinfo/" + og?._id),
                    showFor: ["Ticket issued", "issued"],
                  },
                  {
                    label: "Refund",
                    action: () =>
                      navigate("/order/flight/ticket/refund/" + og?._id),
                    showFor: ["Ticket issued", "issued"],
                    hide: og?.status === "Approved", //bookingData?.isRefundable
                  },
                  {
                    label: "Download pdf",
                    action: () => setOpenPDFExport(og?._id),
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Share order",
                    action: () => setOpenEmailExport(og?._id),
                    hide: getTestLevel() !== getTestLevel("dev"),
                  },
                  {
                    label: "Share pnr",
                    action: () => {},
                    hide:
                      !isGDSSupplier(bookingData?.supplier) ||
                      getTestLevel() !== getTestLevel("dev"),
                  },
                  // {
                  //   label: "Issue via intraverse",
                  //   action: () => {},
                  //   hide: !isGDSSupplier(bookingData?.supplier) || (getTestLevel() !== getTestLevel("dev")),
                  // },
                  {
                    label: "Cancel order",
                    action: () => setOpenCancelOrder(og?.flightObj?._id),
                    showFor: ["Not Paid", "booked", "Paid", "issuable"],
                    hide: !checkPermission("cancel:flight-booking"),
                  },
                  {
                    label: "Void",
                    action: () =>
                      navigate("/order/flight/ticket/void/" + og?._id),
                    hide: voidTime - new Date() <= 0,
                    showFor: ["Ticket issued", "issued", "Denied"],
                  },
                ],
              );
          }

          let items = menus?.filter((obj) => {
            const bookingData = og?.flightBooking?.at(0);
            const status = flightStatusMap(og?.status || bookingData?.status);
            // console.log(status, obj?.showFor);
            return (
              (obj?.showFor ? obj?.showFor?.includes(status) : true) &&
              !obj?.hide
            );
          });

          return (items || [])?.map((item, index) => (
            <div
              key={index}
              onClick={() => item?.action()}
              className="font-bold text-sm text-[#444] px-2 py-2 hover:bg-[#818083]/10 border-b"
            >
              {item?.label}
            </div>
          ));
        }}
      </ActionContext.Consumer>
    </div>
  );
}
// Flight menu
